import { replace } from 'react-router-redux';

export const CREATE_ADVICE = 'CREATE_ADVICE';
export const UPDATE_ADVICE = 'UPDATE_ADVICE';
export const TOGGLE_ADVICE = 'TOGGLE_ADVICE';
export const DELETE_ADVICE = 'DELETE_ADVICE';

function adviceCreated(fields) {
  return {
    type: CREATE_ADVICE,
    payload: {
      fields,
    },
  };
}

function adviceUpdated(id, fields) {
  return {
    type: UPDATE_ADVICE,
    payload: {
      id,
      fields,
    },
  };
}

export function createAdvice(fields) {
  return dispatch => {
    dispatch(adviceCreated(fields));
    // Redirecting to advices list
    dispatch(replace('/advices'));
  };
}

export function updateAdvice(id, fields) {
  return dispatch => {
    dispatch(adviceUpdated(id, fields));
    // Redirecting to advices list
    dispatch(replace('/advices'));
  };
}

export function toggleAdvice(advice) {
  return {
    type: TOGGLE_ADVICE,
    payload: {
      advice,
    },
  };
}

export function removeAdvice(advice) {
  return {
    type: DELETE_ADVICE,
    payload: {
      advice,
    },
  };
}



// WEBPACK FOOTER //
// ./src/modules/funnel/actions/advice.js